import { render, staticRenderFns } from "./webSetting.vue?vue&type=template&id=7824ebcc&scoped=true&"
import script from "./webSetting.vue?vue&type=script&lang=js&"
export * from "./webSetting.vue?vue&type=script&lang=js&"
import style0 from "./webSetting.vue?vue&type=style&index=0&id=7824ebcc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7824ebcc",
  null
  
)

export default component.exports